const Notification = ({ text }) => {
  return (
    <div className="notification">
      <div className="notification-text">
        <i className="fas fa-exclamation-triangle"></i>
        <p>{text}</p>
      </div>
    </div>
  );
};

export default Notification;
